import Swiper, { Pagination, EffectFade, Autoplay } from "swiper";
import { pauseAnimation, resumeAnimation, isAnimationStopped } from "../../../../assets/scripts/extends/cookiesManager";

function initSwiper() {
  if (typeof Swiper === "undefined") {
    return false;
  }

  const homeFeaturesSlider = new Swiper(".hero-carousel:not(.is-admin) .hero-carousel__navigation .swiper", {
    spaceBetween: 20,
    slidesPerView: 1,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
  });

  const homeHeadingsSliderOptions = {
    modules: [Pagination, EffectFade, Autoplay],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: ".hero-carousel__pagination",
      clickable: true,
    },
    preloadImages: true,
    watchSlidesProgress: true,
    on: {
      slideChange: function () {
        const currentSlide = this.realIndex;

        homeFeaturesSlider.slideTo(currentSlide, 0);

        const swiperVideos = document.querySelectorAll(".hero-carousel__main video");
        swiperVideos.forEach(function (video) {
          video.pause();
        });

        const activeSlideVideos = homeHeadingsSlider.slides[homeHeadingsSlider.realIndex].querySelectorAll("video");
        if (activeSlideVideos.length > 0 && !isAnimationStopped()) {
          activeSlideVideos.forEach((video) => {
            video.play();
          });
        }
      },
    },
  };

  if (!isAnimationStopped()) {
    homeHeadingsSliderOptions.autoplay = {
      delay: 8000,
    };
  }

  const homeHeadingsSlider = new Swiper(".hero-carousel:not(.is-admin) .hero-carousel__main .swiper", homeHeadingsSliderOptions);

  homeFeaturesSlider.on("click", function () {
    const clickedSlide = homeFeaturesSlider.clickedIndex;

    if (clickedSlide === homeHeadingsSlider.realIndex || clickedSlide === undefined) {
      return;
    }

    homeHeadingsSlider.slideTo(clickedSlide);
  });

  return true;
}

document.addEventListener("DOMContentLoaded", () => {
  const checkSwiperLoaded = setInterval(() => {
    if (initSwiper()) {
      clearInterval(checkSwiperLoaded);
    }
  }, 100);

  const videoControls = document.querySelectorAll(".hero-carousel__video-control");

  if (videoControls.length > 0) {
    videoControls.forEach((control) => {
      control.addEventListener("click", function () {
        const videos = this.closest(".hero-carousel").querySelectorAll(".swiper-slide-active video");

        if (videos.length > 0) {
          videos.forEach((video) => {
            if (video.paused) {
              video.play();
              this.classList.remove("play");
            } else {
              video.pause();
              this.classList.add("play");
            }
          });
        }
      });
    });
  }
});
